import React, { Component } from 'react'
import Header from './components/header'
import Footer from './components/footer'
import PageTilte from './components/pageTilte';
import {
    Link,
    // Switch, Route 
} from 'react-router-dom';
import axios from 'axios';
import { constantApp } from '../../config/constant';

import Pagination from './components/news/pagination';
import { paginate } from './components/news/paginate';

import { myDate } from '../../Function/dateTime';
// import NewsDetail from './newsDetail';

class News extends Component {
    constructor(props) {
        super(props);

        this.state = {
            data: [],
            isLoading: true,
            currentPage: 1,
            pageSize: 3,
            // isNetworkError: false
        };


    }




    componentDidMount = async () => {
        // console.log('History :', this.props.history)
        window.scrollTo(0, 0)


        const url = `${constantApp.SERVERIP}:${constantApp.PORT_APPACHE}/PHP/News/ListNews.php`;
        const param = {
            isLIMIT: false
        }

alert(JSON.stringify(url));

        let data = await axios.post(url, param)
            .then(function (response) {
                return response.data;
            })
            .catch(function (error) {
                // this.setState({ isNetworkError: true })
                // console.log('error :::', error)
            });

        
            alert(JSON.stringify(data));
            console.log(JSON.stringify(data));
        if (data !== undefined && data.length > 0) { this.setState({ data, isLoading: false }); }
    }




    handlePageChange = page => {

        this.setState({ currentPage: page });
    };

    getPageData = () => {
        const { pageSize, currentPage, data: allPosts } = this.state;
        const posts = paginate(allPosts, currentPage, pageSize);

        return {
            totalCount: allPosts.length,
            data: posts
        };
    };



    render() {
        const { pageSize, currentPage } = this.state;
        const { totalCount, data } = this.getPageData();
        return (
            <div className="page-wrapper" >
                <Header />

                <PageTilte title={'خبرهای شرکت'} />

                {this.state.isLoading ? <section className="blog-grid-section section-padding">
                    <div className="container " style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyItems: 'center', justifyContent: 'center' }}>
                        <i className="fa fa-circle-o-notch fa-spin" style={{ fontSize: 24 }}></i>
                        <br />
                        <p >در حال بارگزاری اطلاعات</p>
                    </div>
                </section> :



                    <section className="blog-grid-section section-padding">
                        <div className="container">
                            <div className="news-grids">


                                {data.map((item) => {
                                    return (
                                        <div className="grid" key={item.idNews}>
                                            <div className="entry-media">

                                                <img src={process.env.PUBLIC_URL + `assets/images/news/img-${item.idNews}.jpg`} alt='' role='presentation' />

                                            </div>
                                            <div className="entry-details">
                                                <div className="entry-meta">
                                                    <ul>
                                                        <li><span className="fa fa-clock-o"></span> {myDate(item.DateSabt)}</li>
                                                    </ul>
                                                </div>
                                                <div className="entry-body">
                                                    <h3><Link to={{
                                                        pathname: `news/${item.idNews}`,
                                                        state: { id: item.idNews }
                                                    }}> {item.Title.length < 55 ? `${item.Title}` : `${item.Title.substring(0, 55)}...`}</Link></h3>
                                                    <p>  {`${item.Brief.substring(0, 40)}...`}</p>

                                                </div>

                                            </div>
                                        </div>

                                    )
                                })}


                            </div>

                            <Pagination
                                itemCount={totalCount}
                                pageSize={pageSize}
                                currentPage={currentPage}
                                onPageChange={this.handlePageChange}
                            />


                        </div>
                    </section>


                }


                <Footer />




            </div>
        );
    }
};

export default News; 